<template>
    <div class="alm-switch-wrapper">
        <f-switch v-model:checked="isChecked" @update:checked="onChange" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Localizer } from "@/api/Localizer";

export default defineComponent({
    props: {
        params: Object,
    },
    data() {
        return {
            localizer: new Localizer(this.$store),
        };
    },
    computed: {
        isChecked() {
            return this.params?.data?.include || false;
        },
    },
    methods: {
        onChange(checked: boolean) {
            if (this.params?.data) {
                this.params.data.include = checked;
                this.params.api?.refreshCells?.({ rowNodes: [this.params.node] });
            }
        },
    },
});
</script>

<style >
.alm-switch-wrapper {
    height: 100%;
    cursor: pointer;
}

.alm-switch-wrapper .ant-switch {
    min-width: 28px;
    height: 16px;
}

.alm-switch-wrapper .ant-switch-checked {
    background-color: var(--green-robinsegg);
}

.alm-switch-wrapper .ant-switch .ant-switch-handle {
    width: 12px;
    height: 12px;
    left: 2px;
}

.alm-switch-wrapper .ant-switch-checked .ant-switch-handle {
    left: calc(100% - 14px);
}
</style>
